import { Check, Events, Log, SessionProvider } from 'core/infrastructure';
import { SalesOrderFacade } from 'pos/facades';

let intervalId: Nullable<NodeJS.Timeout> = null;
// Para evitar reentradas en check si se tarda en ejecutar más del tiempo del interval
let checking = false;

export function start() {
	if (SessionProvider.isDeliveryEnabled() === false)
		return;

	Check.ensure(intervalId === null, 'El monitor de pedidos ya se encuentra arrancado');

	intervalId = setInterval(checkNewTakeOutOrders, 10000);
	Log.debug('Iniciado monitor de pedidos');
}

export function stop() {
	if (SessionProvider.isDeliveryEnabled() === false)
		return;

	Check.ensure(intervalId !== null, 'El monitor de pedidos ya se encuentra parado');
	clearInterval(intervalId!);
	intervalId = null;
	Log.debug('Parado monitor de pedidos');
}

export function forceUpdate(): Promise<void> {
	return checkNewTakeOutOrders();
}

function isEnabled(): boolean {
	return intervalId !== null;
}

async function checkNewTakeOutOrders(): Promise<void> {
	if (!isEnabled() || checking)
		return;

	try {
		Log.debug('Comprobando si hay pedidos nuevos');
		checking = true;
		const count = await SalesOrderFacade.getNewTakeOutOrderCount();

		// Podrían haber deshabilitado el chequeo mientras esperaba la respuesta del servidor
		if (!isEnabled())
			return;

		await Events.raise('pos:takeout-order:new-orders-count', { count });
	}
	catch (e) {
		Log.warn(`No se ha podido comprobar si hay nuevos pedidos: ${e}`);
	}
	finally {
		checking = false;
	}
}